import { Base64 } from "js-base64";
import React, { Fragment, useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { AppContext, SocketCommand, socketManager } from "../../components/AppProvider";
import { PostApi154 } from "../../modules/network/padoPost";
import { _O } from "../../modules/utils";
import { setCookie, setCookieWs } from "../../modules/utils/cookie";
import { IC } from "../../resources/Assets";
import { ContainerNew, SubMenu } from "../Layout";
import useTitle from "../../modules/hooks/useTitle";

export default (props) => {
  const { phonecfg, cfg } = useContext(AppContext);
  useTitle("회원가입_채널선택");
  const [viewPage, setViewPage] = useState(false);

  const goSnsLogin = (param) => {
    // setCookie("isAutologin", isAutoLogin, 365);

    if (param === "KAKAO") {
      setCookie("signUpChannel", "400", 1);
      setCookieWs({ isAutoLogin: true, signUpChannel: "400" });
      window.location.href = "ep://login/kakao";
    }

    if (param === "NAVER") {
      setCookie("signUpChannel", "100", 1);
      setCookieWs({ isAutoLogin: true, signUpChannel: "100" });
      window.location.href = "ep://login/naver";
    }

    if (param === "APPLE") {
      setCookie("signUpChannel", "600", 1);
      socketManager(SocketCommand.LOGIN_APPLE, appleLoginAf, {});
    }
  };

  const appleLoginAf = (userEmail, userName, UID, signUpChannel) => {
    setCookieWs({ isAutoLogin: true, signUpChannel: "600" });
    if (userEmail && userEmail != null) {
      _O.Open(
        "/membership/snsLogin/" + userEmail + "/" + userName + "/" + UID + "/" + signUpChannel
      );
    } else {
      _O.Open("/membership/appleLogin/" + UID + "/" + signUpChannel);
    }
  };

  useEffect(() => {
    const userInfo = JSON.parse(Base64.decode(props.match.params.info));
    setCookie("authCheck", props.match.params.info);

    PostApi154(
      phonecfg,
      cfg,
      userInfo.userName,
      userInfo.userPhone,
      userInfo.userBirth,
      userInfo.Gender,
      userInfo.userDI,
      "",
      userInfo.isForeigner
    ).then((res) => {
      if (res.resultCode === "000") {
        if (res.joinInfo.length > 0) {
          _O.Open("/membership/findID/" + Base64.encode(JSON.stringify(res.joinInfo)));
        } else {
          setViewPage(true);
        }
      }
    });
  }, []);

  return (
    <Fragment>
      {viewPage ? (
        <ContainerNew
          Title={"본인인증"}
          dark={"dark"}
          leftMenu={SubMenu}
          rightMenu={-1}
          isMain={true}
          // bottom={bottom}
          goToUrl={"/membership/serviceTerms/000"}
        >
          <Contents>
            <SubTitle>SNS 간편 가입</SubTitle>
            <SnsLoginComponentArea>
              <div
                style={{
                  padding: "37px 0px",
                }}
              >
                <img
                  src={IC.login.IC_LOGIN_KAKAO}
                  style={{ width: "100%", height: "44px" }}
                  onClick={() => goSnsLogin("KAKAO")}
                />
                <img
                  src={IC.login.IC_LOGIN_NAVER}
                  style={{ width: "100%", height: "44px" }}
                  onClick={() => goSnsLogin("NAVER")}
                />
                {phonecfg.phoneOS === "IOS" && (
                  <img
                    src={IC.login.IC_LOGIN_APPLE}
                    style={{ width: "100%", height: "44px" }}
                    onClick={() => goSnsLogin("APPLE")}
                  />
                )}
              </div>
            </SnsLoginComponentArea>

            <SubTitle>아이디로 가입</SubTitle>
            <div style={{ padding: "12px 20px" }}>
              <div
                style={{
                  width: "100%",
                  height: "48px",
                  lineHeight: "48px",
                  background: "#e3e2e2",
                  borderRadius: "24px",
                  textAlign: "center",
                  marginTop: "16px",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
                onClick={() => _O.Open("/membership/addAccount/manual/" + props.match.params.info)}
              >
                아이디/비밀번호 생성
              </div>
            </div>
          </Contents>
        </ContainerNew>
      ) : (
        <Fragment>
          <div>정보 확인 중</div>
        </Fragment>
      )}
    </Fragment>
  );
};

const Contents = ({ children }) => {
  return (
    <div className="contents">
      <div className="sub-contents">{children}</div>
    </div>
  );
};

const SnsLoginComponentArea = ({ children }) => {
  return (
    <div>
      <div
        style={{
          textAlign: "center",
          padding: "12px 20px",
        }}
      >
        {children}
      </div>
    </div>
  );
};

const SubTitle = styled.div`
  font-size: 24px;
  font-weight: 700;
  margin-top: 37px;
`;
